<template>
  <v-card flat class="pa-0 ma-0">
    <v-card-title>
      Opciones
      <v-spacer></v-spacer>
      <v-text-field
        v-model="newOption"
        label="Nueva opción"
        dense
        persistent-hint
        hint="Escribe una nueva opción y presiona enter para agregarla"
        @keyup.enter="addOption"
      >
        <template v-slot:append>
          <v-btn icon small @click="addOption" :disabled="!newOption.trim()">
            <v-icon>mdi-plus</v-icon>
          </v-btn>
        </template>
      </v-text-field>
    </v-card-title>
    <v-card-text>
      <div class="d-flex flex-wrap" style="gap: 0.25rem">
        <v-chip
          v-for="(option, index) in value"
          :key="index"
          small
          close
          @click:close="removeOption(index)"
        >
          {{ option }}
        </v-chip>
      </div>
      <span v-if="!value.length">Sin opciones</span>
    </v-card-text>
  </v-card>
</template>
<script>
export default {
  name: "OptionsSection",
  props: {
    value: {
      type: Array,
      default: () => []
    }
  },
  data() {
    return {
      newOption: "",
      options: new Set(this.value)
    };
  },
  methods: {
    addOption() {
      if (!this.newOption.trim()) return;

      this.options.add(this.newOption.trim());
      this.newOption = "";
      this.$emit("input", Array.from(this.options));
    },
    removeOption(index) {
      this.options.delete(this.value[index]);
      this.$emit("input", Array.from(this.options));
    }
  }
};
</script>
